<template>
  <div class="compose-box">
    <ybl-num-range v-model="item.defaultVal" :unit="unit" :showUnit="true" @change="selectChange"></ybl-num-range>
    <el-select v-model="item.valFlag" placeholder="请选择" :filterable="true" clearable @change="selectChange">
      <el-option v-for="o in item.valueDictList" :key="o.keyCode" :label="o.keyVal" :value="o.keyCode"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'yblCompose',
  props: {
    field: { // 字段对象
      type: Object,
      default: () => null
    },
    unit: {
      type: String,
      default: () => '万元'
    }
  },
  data () {
    return {
      item: {
        valueDictList: [],
        valFlag: ''
      }
    }
  },
  created () {
    const callConfig = JSON.parse(this.field.callConfig)
    const valueKey = callConfig.ValueKey
    this.item.valueDictList = this.field.dictList.filter(item => item.busiCode === valueKey)
    this.item = {...this.item, ...this.field}
    // console.log('this.item = ', this.item, this.field)
  },
  methods: {
    selectChange () {
      console.log('this.item = ', this.item)
      this.$emit('change', this.item)
    }
  }
}
</script>

<style lang="less">
.compose-box{
  display: flex;
  .el-select{
    width: 100px !important;
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/compose.vue